import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateTransactionSeries() {
  const queryClient = useQueryClient()

  const action = async ({ id }) => {
    const response = await httpClient.delete(`team/cash-flow/series/${id}`)
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      // queryClient.invalidateQueries({
      //   queryKey: ['transaction-repeat-options'],
      // })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })

      toast.success('Transaction series successfully added.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
